// the code from Google, which was adapted below, is not at all typescript safe
// @ts-nocheck
import { TELEM_FUNC_NORMAL } from './constants'

export function injectGoogleAnalytics(
  instrumentationId: string,
  telemetryFunc = TELEM_FUNC_NORMAL
): void {
  // need to ensure data layer names are unique
  const dataLayerName = `dataLayer_${instrumentationId}`.replace(/[_-]/g, '')

  // download google script
  const script = document.createElement('script')
  script.src = `https://www.googletagmanager.com/gtag/js?id=${instrumentationId}&l=${dataLayerName}`
  document.head.appendChild(script)

  // code below this line suggested by Google
  window[dataLayerName] = window[dataLayerName] || []

  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window[dataLayerName].push(arguments)
  }

  gtag('js', new Date())
  gtag('config', instrumentationId, { send_page_view: false })

  window[telemetryFunc] = gtag
}

export default injectGoogleAnalytics
